import React from "react";
import {
  Waves, Wrench, ShowerHead, Flame, Siren, Sparkles, Trash2, Hammer, Pipette, ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "../../lib/site-data";

const ICONS = { Waves, Wrench, ShowerHead, Flame, Siren, Sparkles, Trash2, Hammer, Pipette };

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#F3F4F6] py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] mb-4">
            What We Do
          </div>
          <h2
            data-testid="services-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1D2B53] tracking-tight leading-tight"
          >
            Plumbing &amp; home services, done the right way.
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            One trusted local team for everything from drain cleaning to power washing.
          </p>
        </div>

        <div
          data-testid="services-grid"
          className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6"
        >
          {SERVICES.map((s) => {
            const Icon = ICONS[s.icon] || Wrench;
            const id = slug(s.title);
            return (
              <article
                key={s.title}
                data-testid={`service-card-${id}`}
                className="group relative bg-white rounded-2xl p-8 border border-gray-100 hover:border-[#2563EB]/30 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-[#1D2B53]/10 transition-all duration-300"
              >
                <div className="flex items-start justify-between">
                  <div className="h-14 w-14 rounded-xl bg-[#2563EB]/10 group-hover:bg-[#2563EB] flex items-center justify-center transition-colors duration-300">
                    <Icon className="h-7 w-7 text-[#2563EB] group-hover:text-white transition-colors duration-300" strokeWidth={1.75} />
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-gray-300 group-hover:text-[#2563EB] group-hover:rotate-12 transition-all duration-300" />
                </div>

                <h3 className="mt-6 font-display text-xl font-bold text-[#1D2B53]">
                  {s.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-gray-600">
                  {s.desc}
                </p>

                <a
                  href="#contact"
                  data-testid={`service-card-${id}-cta`}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-[#2563EB] hover:gap-2.5 transition-all"
                >
                  Learn More
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
